<template>
    <div class="barrage">
      <div
        v-for="(row, rowIndex) in rows"
        :key="rowIndex"
        class="barrage-row"
        :class="rowIndex % 2 === 0 ? 'left' : 'right'"
        :style="{
          animationDuration: `${40 + rowIndex * 5}s`,
          '--bubble-color': colors[rowIndex % colors.length]
        }"
      >
        <!-- 复制两遍，保证无缝 -->
        <template v-for="n in 2">
          <div
            v-for="(item, index) in row"
            :key="n + '-' + index"
            class="bubble"
            @click="handleClick(item)"
          >
            {{ item.topic }}
          </div>
        </template>
      </div>
    </div>
</template>
  
  <script setup>
  import { ref } from 'vue'
  import { addTopicScore } from '@/api/2025'
  
const props = defineProps({
  list: {
    type: Array,
    default: () => {
      return []
    }
  }
})
  
// 每行颜色
const colors = [
    'linear-gradient(180.00deg, rgb(0, 206, 139),rgb(0, 160, 108) 100%)',
    'linear-gradient(180.00deg, rgb(228, 25, 164),rgb(156, 0, 134) 100%)',
    'linear-gradient(180.00deg, rgb(255, 180, 41),rgb(255, 122, 0) 96.947%)',
    'linear-gradient(180.00deg, rgb(70, 137, 255),rgb(14, 93, 232) 100%)',
    'linear-gradient(180.00deg, rgb(61, 207, 233),rgb(14, 141, 164) 100%)'
]

// 将 list 按每行5个分组
const rows = ref([])
    for (let i = 0; i < props.list.length; i += 5) {
    rows.value.push(props.list.slice(i, i + 5))
}

const handleClick = (item) => {
  // let path = `https://www.n.cn?q=${item.topic}`
  // window.location.href = path
}

  </script>
  
  <style scoped>
  .barrage {
    width: 100%;
    overflow: hidden;
    padding: 10px 0;
  }
  
  .barrage-row {
    display: flex;
    width: max-content;
    animation: moveLeft linear infinite;
    margin-bottom: 12px;
  }
  
  .bubble {
    background: var(--bubble-color);
    color: #fff;
    font-weight: 600;
    border-radius: 999px;
    white-space: nowrap;
    margin-right: 10px;
    font-size: 14px; /* 固定字体大小 */
    padding: 6px 16px; /* 给气泡留点内边距 */
    transition: transform 0.3s;
  }
  
  /* .bubble:hover {
    transform: scale(1.2);
  } */
  
  @keyframes moveLeft {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  
  @keyframes moveRight {
    0% {
      transform: translateX(-50%);
    }
    100% {
      transform: translateX(0);
    }
  }
  
  .left {
    animation-name: moveLeft;
  }
  
  .right {
    animation-name: moveRight;
  }
  </style>
  